import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import EmailCapturePopup from "./components/EmailCapturePopup";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Intake from "./pages/Intake";
import IntakeSuccess from "./pages/IntakeSuccess";
import IntakeComplete from "./pages/IntakeComplete";
import Assessment from "./pages/Assessment";
import Symptoms from "./pages/Symptoms";
import MyStory from "./pages/MyStory";
import Schedule from "./pages/Schedule";
import PatientMessages from "./pages/PatientMessages";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import MedicalDisclaimer from "./pages/MedicalDisclaimer";
import HealthPrivacyNotice from "./pages/HealthPrivacyNotice";
import ThankYou from "./pages/ThankYou";
import EligibilityConfirmed from "./pages/EligibilityConfirmed";
import LandingPage from "./pages/LandingPage";
import BridgePage from "./pages/BridgePage";
import PerimenopauseLanding from "./pages/PerimenopauseLanding";
import PMOSLanding from "./pages/PMOSLanding";
import MenopauseLanding from "./pages/MenopauseLanding";
import PMDDLanding from "./pages/PMDDLanding";
import PostpartumLanding from "./pages/PostpartumLanding";
import ThyroidLanding from "./pages/ThyroidLanding";
import AdminDashboard from "./pages/AdminDashboard";

// Layout wrapper that conditionally renders Nav/Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isStandalonePage = location.pathname === '/lp' || location.pathname === '/landing' || location.pathname === '/book' || location.pathname === '/perimenopause' || location.pathname === '/pcos' || location.pathname === '/pmos' || location.pathname === '/menopause' || location.pathname === '/pmdd' || location.pathname === '/postpartum' || location.pathname === '/thyroid' || location.pathname.startsWith('/admin');
  
  return (
    <>
      {!isStandalonePage && <Navigation />}
      {!isStandalonePage && <EmailCapturePopup />}
      <main>{children}</main>
      {!isStandalonePage && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/symptoms" element={<Symptoms />} />
            <Route path="/mystory" element={<MyStory />} />
            <Route path="/intake" element={<Intake />} />
            <Route path="/intake/success" element={<IntakeSuccess />} />
            <Route path="/intake-complete" element={<IntakeComplete />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/portal" element={<PatientMessages />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/medical-disclaimer" element={<MedicalDisclaimer />} />
            <Route path="/health-privacy-notice" element={<HealthPrivacyNotice />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/eligibility-confirmed" element={<EligibilityConfirmed />} />
            <Route path="/lp" element={<LandingPage />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/book" element={<BridgePage />} />
            <Route path="/perimenopause" element={<PerimenopauseLanding />} />
            <Route path="/pcos" element={<PMOSLanding />} />
            <Route path="/pmos" element={<PMOSLanding />} />
            <Route path="/menopause" element={<MenopauseLanding />} />
            <Route path="/pmdd" element={<PMDDLanding />} />
            <Route path="/postpartum" element={<PostpartumLanding />} />
            <Route path="/thyroid" element={<ThyroidLanding />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
